// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2LOnh","title":"ClientInsurance_title__Enx3z","itemText":"ClientInsurance_itemText__c9FBf"};